<template>
  <v-container>
    <the-dialog-box
      ref="dialogBox"
      :submit="() => {}"
      :max-width="1500"
      :max-height="1000"
    >
      <template slot="header">
        <span class="headline">UPC Receiving</span>
      </template>
      <template slot="body">
        <v-container
          style="font-size: 1.3em !important;"
          fluid
          class="mt-3"
        >
          <v-row>
            <v-col cols="12" md="3">
              <v-card outlined class="rounded-lg">
                <v-card-text class="pa-5">
                  <div class="text-subtitle-2 text-uppercase grey--text text--darken-1 mb-1 text-center">
                    UPC Code
                  </div>
                  <div class="text-h4 font-weight-bold text--primary mb-3 text-center">
                    {{ qrCode }}
                  </div>
                  <div class="text-center">
                    <v-chip
                      class="px-4 py-2 font-weight-bold upc-identification-chip"
                      text-color="white"
                      :color="inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.color : 'white'"
                    >
                      {{ inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.name : '-' }}
                    </v-chip>
                  </div>
                  <div
                    v-if="businessRulesGetBoolean('Inventory Sub Class') && inventoryTag && inventoryTag.item && inventoryTag.item.sub_classes && inventoryTag.item.sub_classes.length > 0"
                    class="text-center mt-4"
                  >
                    <div class="text-subtitle-2 grey--text text--darken-2 mb-2">
                      Inventory Sub Classes
                    </div>
                    <v-chip
                      v-for="subclass in inventoryTag.item.sub_classes"
                      :key="`subclass-${subclass.id}`"
                      class="ma-1 px-4 py-2 upc-identification-chip"
                      text-color="white"
                      :color="subclass.color || 'white'"
                    >
                      {{ subclass.name }}
                    </v-chip>
                  </div>
                  <v-divider class="my-4" />
                  <v-img
                    v-if="inventoryTag && inventoryTag.item && inventoryTag.item.photo && inventoryTag.item.mime_type"
                    :src="convertedPhoto(inventoryTag.item.photo, inventoryTag.item.mime_type)"
                    contain
                    max-height="240"
                    class="mx-auto my-4"
                  />
                  <v-sheet
                    v-else
                    height="240"
                    color="grey lighten-4"
                    class="rounded d-flex flex-column align-center justify-center my-4"
                  >
                    <v-icon large color="grey">mdi-image-outline</v-icon>
                    <div class="text-caption grey--text text--darken-1 mt-2">
                      No item image
                    </div>
                  </v-sheet>
                  <div class="text-caption grey--text text--darken-1">
                    Item Image
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="9">
              <v-card outlined>
                <v-card-title>Inventory Tag Details</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <h5 class="h5">Inventory Item</h5>
                      <span>{{ inventoryTag ? inventoryTag.item_full_name : '' }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="pt-0">
                      <h5 class="h5">Length</h5>
                      <span>{{ inventoryTag ? inventoryTag.length_name : '' }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="pt-0">
                      <h5 class="h5">UOM</h5>
                      <span>{{ inventoryTag ? inventoryTag.uom_name : '' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <h5 class="h5">
                        Location
                      </h5>
                      <span>{{ inventoryTag ? inventoryTag.location_name : '' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <h5 class="h5">
                        Shelf
                      </h5>
                      <span>{{ inventoryTag ? inventoryTag.inventory_location_name : '' }}</span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <h5 class="h5">
                        Qty on Hand
                      </h5> <span> {{ inventoryTag ? inventoryTag.quantity_on_hand : '' }}</span>
                    </v-col>
                    <v-col
                      v-if="dangerLevel && dangerLevel.limit_level"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <h5 class="h5">
                        Limit Level
                      </h5> <span> {{ dangerLevel ? dangerLevel.limit_level : '' }}</span>
                    </v-col>
                    <v-col
                      v-if="dangerLevel && dangerLevel.danger_level"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <h5 class="h5">
                        Danger Level
                      </h5> <span> {{ dangerLevel ? dangerLevel.danger_level : '' }}</span>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <h5 class="h5">Color</h5>
                      <span>{{ inventoryTag ? inventoryTag.color_name : '' }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card outlined class="mt-4">
                <v-card-title>Receiving</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="quantity"
                        outlined
                        :disabled="submittedSuccessfully"
                        :rules="[(v) => !!v || 'Quantity is required']"
                        type="number"
                      >
                        <template slot="label">
                          Quantity Received<RedAsterisk />
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-autocomplete
                        v-model="poNumber"
                        outlined
                        :items="inventoryPos"
                        :clearable="true"
                        label="PO#"
                        :rules="[(v) => !!v || 'PO# is required']"
                        :disabled="inventoryPoItemId != null"
                      >
                        <template slot="label">
                          PO#<RedAsterisk />
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                      cols="12"
                      sm="6"
                      class="pt-0"
                    >
                      <v-file-input
                        v-model="supplierLabel"
                        outlined
                        accept="image/*"
                        capture="user"
                        label="Supplier Label"
                        item-text="name"
                        item-value="id"
                      >
                        <template slot="label">
                          Supplier Label<RedAsterisk />
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template #actions>
        <v-spacer />
        <v-btn :disabled="!submittedSuccessfully" @click="print" color="secondary">Print</v-btn>
        <v-btn @click="closeDialog">Close</v-btn>
        <v-btn @click="submit" :disabled="submittedSuccessfully" color="primary">Submit</v-btn>
      </template>
    </the-dialog-box>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data: () => ({
    qrCode: '',
    inventoryTag: null,
    inventoryTagId: null,
    supplierLabel: null,
    dangerLevel: null,
    poNumber: '',
    quantity: 0,
    // maxInputQuantity: 0,

    inventoryPos: [],

    inventoryClassIdGlass: 5,
    inventoryClassIdVWDGlass: 7,
    inventoryClassIdParts: 11,

    inventoryPoItemId: null,

    data: null,
    submittedSuccessfully: false,
  }),
  computed: {
    ...mapGetters([
      'isPhysicalCountActivated',
      'currentPhysicalCount',
      'businessRulesGetBoolean',
    ]),
    ...mapState({
      userId: (state) => state.user.id,
    }),
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async open(qrCode, data) {
      this.$refs.dialogBox.open();
      this.submittedSuccessfully = false;
      this.supplierLabel = null;
      this.dangerLevel = null;
      this.quantity = 0;
      this.qrCode = qrCode;

      if (data) {
        this.poNumber = data.po_number || '';
        this.inventoryPoItemId = data.inventory_po_item_id || null;
        this.data = data || null;
      }

      await this.getInventoryTag();
      await this.getDangerLevel();
      await this.getInventoryPos();
      await this.upsertInventoryBlob();
    },

    async upsertInventoryBlob() {
      try {
        const text = window.location.href;
        const name = this.inventoryTag.item?.name || `QR ${this.inventoryTag.inventory_tag}`;
        const res = await this.$api.inventoryBlob.store({ id: this.inventoryTag.inventory_tag, text, name });

        if (!res || res.err) {
          this.$bus?.$emit?.('showError', res?.errDesc || 'Failed to generate QR.');
        }
      } catch (e) {
        console.error('[inventory_blob/upsert] Error:', e);
        this.$bus?.$emit?.('showError', 'Unexpected error while generating QR.');
      }
    },

    async getInventoryTag() {
      if (!this.qrCode) return;

      const isQtyOnHandZero = 0;

      const submitModel = {
        filters: {
          inventory_tag: this.qrCode,
          is_qty_on_hand_o: isQtyOnHandZero,
        },
        includes: {
          is_include_item_image: true,
          is_include_supplier_label: true,
        },
      };

      const res = await this.$api.inventoryTag.read(submitModel);
      if (!res || !res.data || !res.data[0]) {
        this.$bus.$emit('showError', 'Inventory Tag not found');
        return;
      }
      const firstIndex = 0;
      let data = res.data[firstIndex];
      if (this.isPhysicalCountActivated && this.currentPhysicalCount && this.currentPhysicalCount.classes && this.currentPhysicalCount.classes.some((c) => c.id === data.item.inventory_class_id)) {
        // get the physical count record
        const submitModel2 = {
          filters: {
            inventory_tag: this.qrCode,
            physical_count_list_id: this.currentPhysicalCount.id,
          },
        };
        const res2 = await this.$api.physicalCount.read(submitModel2);
        if (res2 && res2.data && res2.data[0]) {
          const { item } = data;
          data = res2.data[0];
          data.quantity_on_hand = data.quantity;
          data.item = item;
        }
      }
      this.inventoryTagId = data.inventory_tag;
      this.inventoryTag = data;
    },

    async getDangerLevel() {
      if (this.inventoryTag && this.inventoryTag.item && this.inventoryTag.item.classes && this.inventoryTag.item.classes.id !== this.inventoryClassIdParts) return;
      if (!this.qrCode) return;

      const submitModel = {
        filters: {
          inventory_item_id: this.inventoryTag.inventory_item_id,
        },
      };

      const res = await this.$api.dangerLevel.read(submitModel);
      if (!res || res.length < 1) {
        this.dangerLevel = null;
        return;
      }

      const firstIndex = 0;
      this.dangerLevel = res[firstIndex];
    },

    async getInventoryPos() {
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryTag && this.inventoryTag.item && this.inventoryTag.item.classes && this.inventoryTag.item.classes.id,
        },
      };
      const res = await this.$api.inventoryPo.read(submitModel, null, 'read-simple');
      if (!res) {
        return;
      }
      this.inventoryPos = res;
    },

    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      return `data:${mimeType};base64, ${photo}`;
    },

    setMaxInputQuantity() {
      this.maxInputQuantity = this.dangerLevel && this.inventoryTag ? this.dangerLevel.limit_level - this.inventoryTag.quantity_on_hand : 0;
    },

    closeDialog() {
      if (this.submittedSuccessfully) this.$emit('success');
      this.$refs.dialogBox.close();
    },

    async submit() {
      if (this.submittedSuccessfully) return;
      if (this.isPhysicalCountActivated) {
        // if physical count is activated then if po_number is selected, then we need to query the inventory po and find the inventory po item associated with the currently selected parameters
        if (this.poNumber) {
          const submitData = {
            filters: {
              po_number: this.poNumber,
              inventory_item_id: this.inventoryTag.inventory_item_id,
              uom_id: this.inventoryTag.uom_id,
              length_id: this.inventoryTag.length_id,
              color_id: this.inventoryTag.color_id,
            },
          };

          const res = await this.$api.inventoryPoItem.read(submitData);
          if (!res || res.length === 0) {
            this.$bus.$emit('showError', 'No matching PO Item found for the selected parameters');
            return false;
          }

          // set inventory_po_item_id in data
          this.data = this.data || {};
          this.inventoryPoItemId = res[0].id;
          this.data.inventory_po_id = res[0].inventory_po_id;
        }
      }

      if (!this.inventoryTag) return false;

      this.$bus.$emit('loading');
      const data = new FormData();

      // Qr Code is treated as inv tag for now
      if (this.qrCode) {
        data.append('inventory_tag', this.qrCode);
      }

      if (this.quantity) {
        data.append('quantity', Math.floor(this.quantity));
      }

      if (this.userId) {
        data.append('created_by', this.userId);
      }

      if (this.poNumber) {
        data.append('po_number', this.poNumber);
      }

      if (this.supplierLabel) {
        data.append('supplier_label', this.supplierLabel);
      }

      if (this.inventoryPoItemId) {
        data.append('inventory_po_item_id', this.inventoryPoItemId);
      }

      const res = await this.$api.inventoryTag.upcReceiving(data);

      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading-stop');
        return false;
      }
      if (this.poNumber) {
        const submitData = new FormData();

        if (this.data.inventory_po_id) {
          submitData.append('inventory_po_id', this.data.inventory_po_id);
        }

        if (this.data.packaging_slip) {
          submitData.append('packaging_slip', this.data.packaging_slip);
        }

        if (this.data.packaging_slip_img) {
          submitData.append('packaging_slip_img', this.data.packaging_slip_img);
        }

        const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

        if (!resPo) {
          this.$bus.$emit('showError');
          this.$bus.$emit('loading-stop');
          return false;
        }
      }
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');


      this.submittedSuccessfully = true;
      return true;
    },

    emitSuccess() {
      this.$emit('success');
    },
    async print() {
      //TODO review this function
      if (!this.submittedSuccessfully) return;
      try {
        this.$bus.$emit('loading');
        const WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG = 11;
        const webhookData = {
          module_id: WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG,
          inventory_tag_id: Number(this.inventoryTagId),
          quantity: this.quantity
        };
        const res = await this.$api.webhook.store( webhookData, 'run-download', { responseType: 'blob' });
        if (!res) return this.$bus.$emit('showError', 'Failed to generate PDF');

        const blob = res instanceof Blob ? res : (res.data instanceof Blob ? res.data : new Blob([res], { type: 'application/pdf' }));
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `inventory_tag_${this.inventoryTagId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[reprint] Error:', e);
        this.$bus.$emit('showError', 'Error generating PDF');
      } finally {
        this.$bus.$emit('loading-stop');
      }
    },
  },
};
</script>

<style scoped>
.upc-identification-chip {
  height: auto;
}

.upc-identification-chip >>> .v-chip__content {
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: center;
}

span{
  color: black !important;
}
</style>
